import * as d3 from 'd3'

export default {

  methods: {

    gmx_valueHovor(selection, id, x, y, align, out, over){
      let node = this.getNode(`#${id}`, 'width') / 5.5
      if (align == 'end') node = node + 0
      if (align == 'start') node = node * -1
      if (align == 'middle') node = 0

      selection
      .on('mouseover', function() {
        d3.select(this).transition().duration(100)
        .attr('transform', `translate(${x + node}, ${y+1}) scale(1.3)`).style('fill', over)
      })
      .on('mouseout', function(){
        d3.select(this).transition().duration(100)
        .attr('transform', `translate(${x}, ${y}) scale(1)`).style('fill', out)
      })     
    },


    gmx_textTween(id, value, dur, unit, x, y, color, align, fixed = 0) {
      if(unit == null || unit == '') unit = ''

      d3.select(id).transition().duration(dur)
      .tween("text", function() {
        let oldValue = (d3.select(this).text()).replaceAll(' ', '').replaceAll(unit, '')
        var i = d3.interpolateNumber(oldValue, value)
        return function(t) {
        d3.select(this).text(`${i(t).toFixed(fixed)}${unit}`)
        }
      })
      .attr('x', function() {
        if(x) return x; else return d3.select(this).attr('x')
      })
      .attr('y', function() {
        if(y) return y; else return d3.select(this).attr('y')
      })
      .attr('fill', function() {
        if(color) return color; else return d3.select(this).attr('fill')
      })
      .attr('text-anchor', function() {
        if(align) return align; else return d3.select(this).attr('text-anchor')
      })
    },

    
    gmx_Effect_Radio(onOff, id, code, opacity, weight, color) {
      if(onOff=='off') {
        d3.select(`#${id}_${code}`).attr('opacity', opacity) 
        d3.select(`#${id}_TEXT_${code}`).attr('font-weight', weight)
        d3.select(`#${id}_IN_${code}`).attr('fill', '#fff')
        d3.select(`#${id}_OUT_${code}`).attr('stroke', color)
      } else {
        d3.select(`#${id}_${code}`).attr('opacity', opacity) 
        d3.select(`#${id}_TEXT_${code}`).attr('font-weight', weight)
        d3.select(`#${id}_IN_${code}`).attr('fill', color)
        d3.select(`#${id}_OUT_${code}`).attr('stroke', color)
      }
    },


    gmx_toggleButton(selection, s, execFunc) {
      let status = this[s.variable]

      let toggle = selection
      .append('g')
      .attr('id', `${s.id}_GROUP`)
      .attr('transform', `translate(${s.x}, ${s.y})`)
      .attr('font-size', s.tSize ? s.tSize : 10).attr('cursor', 'pointer')
      .on('click', () => { 
        (this[s.variable] == 'on') ? this[s.variable] = 'off' :this[s.variable] = 'on'
        
        let status = this[s.variable]
        d3.select(`#${s.id}_BG`).attr('fill', s[status].bColor)
        d3.select(`#${s.id}_SLIDER`).transition().attr('cx', (status=='on') ? s.height/2 : s.width-(s.height/2))
        d3.select(`#${s.id}_TEXT`).transition()
        .attr('x', (status=='on') ? s.width-(s.height/2) : s.height/2)
        .attr('text-anchor', (status=='on') ? 'end' : 'start')
        .attr('fill', s[status].tColor)
        .text(s[status].value)

        execFunc() // ----->
      })
      
      toggle
      .append('rect')
      .attr('id', `${s.id}_BG`)
      .attr('width', s.width).attr('height', s.height).attr('fill', s[status].bColor).attr('rx', s.height/2)

      toggle
      .append('circle')
      .attr('id', `${s.id}_SLIDER`)
      .attr('cx', s.height/2).attr('cy', s.height/2).attr('r', s.radius ? s.radius : 6).attr('fill', s.cColor)

      toggle
      .append('text')
      .attr('id', `${s.id}_TEXT`)
      .attr('x', s.width-(s.height/2)).attr('y', s.height/2 + 10*0.35).attr('text-anchor', 'end')
      .attr('fill', s[status].tColor)
      .text(s[status].value)

      selection
      .append('text')
      .attr('x', s.x + s.width+5).attr('y', s.y + s.height/2 + 10*0.35)
      .style('fill', '#000').attr('font-size', s.tSize ? s.tSize : 10)
      .text(s.title)
    },


    gmx_btn_Navigation(selection, style_, exec) {
      let defs = this.svg.append('defs')
      let grayGrandient = defs.append('linearGradient')
      .attr('id', `grayGrandient`).attr('x1', 0).attr('x2', 1).attr('y1', 0).attr('y2', 1)
      grayGrandient.append('stop').attr('stop-color', '#D2D8D9').attr('offset', '0').attr('stop-opacity', 1)
      grayGrandient.append('stop').attr('stop-color', '#FFFFFF').attr('offset', '1').attr('stop-opacity', 1)

      let home = 'M29.9,19.4l-5.2-5.2l-5.2-5l-5.2,5l-5.2,5.2h3.4v9.2h5.1v-7.2h3.8v7.2h5.1v-9.2 C26.5,19.4,29.9,19.4,29.9,19.4z'
      let back = 'M25.2,27.3c0.4,0.2,0.7,0,0.7-0.4V11.5c0-0.5-0.3-0.7-0.7-0.4l-13.3,7.8c-0.4,0.2-0.4,0.6,0,0.9 L25.2,27.3z'

      var btn_Home = selection
      .append('g')
      .attr('class', `Nav_btn`)
      .attr('transform', `translate(${style_.x}, ${style_.y})scale(${style_.scale})`)
      .style('cursor', 'pointer')
      .on('mouseover', () => {
        btn_Home.transition().duration(150).style("opacity", 0.5)
      })
      .on('mouseout', () => {
        btn_Home.transition().duration(150).style("opacity", 1)
      })
      .call(this.gmx_callNavi, exec)

      btn_Home
      .append('path').attr('fill', '#B5BCBF')
      .attr('d', 'M2,29.5c0,5,4.1,9.1,9.1,9.1h18.2c5,0,9.1-4.1,9.1-9.1V11.2c0-5-4.1-9.1-9.1-9.1H11.1 c-5,0-9.1,4.1-9.1,9.1C2,11.2,2,29.5,2,29.5z')
      btn_Home
      .append('path').attr('fill', 'url(#grayGrandient)')
      .attr('d', 'M0.6,28c0,5,4.1,9.1,9.1,9.1h18.2c5,0,9.1-4.1,9.1-9.1V9.8c0-5-4.1-9.1-9.1-9.1H9.7  c-5,0-9.1,4.1-9.1,9.1C0.6,9.8,0.6,28,0.6,28z')
      btn_Home
      .append('path').attr('fill', '#5B6678')
      .attr('d', ()=> {
        if(style_.type == 'home') return home
        if(style_.type == 'back') return back
      })
    },


    gmx_callNavi(selection, exec) {
      let clickTimeout = false

      selection
      .on('mouseover', function() {
        d3.select(this).transition().duration(50).style('opacity', .7)
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(50).style('opacity', 1)
      })
      .on('click', () => {
        if(clickTimeout) return
        if (exec.remove && exec.remove.length > 0) this.gmx_removeExeFunc(exec)
          else exec.exeFunc(exec.data)
        clickTimeout = true
      }) 
    },


    gmx_removeExeFunc(exec) {
      let dur = 500, timeout = 1000

      if(exec.dur || exec.dur == 0) dur = exec.dur
      if(exec.timeout || exec.timeout == 0) timeout = exec.timeout
      exec.remove.forEach(d=> { d.transition().duration(dur).style('opacity', 0) })

      setTimeout(() => { 
        exec.remove.forEach(d=> {
          if(d) d.remove() // remove selection
        })
        exec.exeFunc(exec.data) // Call Function
      }, timeout)
    },


  }
}
